import { render, staticRenderFns } from "./ExpandableDefault.vue?vue&type=template&id=10276922"
import script from "./ExpandableDefault.vue?vue&type=script&lang=js"
export * from "./ExpandableDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports